import { useState } from 'react';
import { kppReject, type KppRow } from './logistics-api';

// Охрана отклоняет машину на КПП с обязательным комментарием (расхождение с накладной и т.п.).
export function KppRejectModal({
  row,
  onClose,
  onDone,
}: {
  row: KppRow;
  onClose: () => void;
  onDone: () => void;
}) {
  const [reason, setReason] = useState(row.reject_reason ?? '');
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState<string | null>(null);

  async function submit() {
    if (!reason.trim()) {
      setMsg('Укажите причину отклонения.');
      return;
    }
    setBusy(true);
    setMsg(null);
    try {
      await kppReject(row.id, reason.trim());
      onDone();
    } catch (e) {
      setMsg(e instanceof Error ? e.message : 'Не удалось отклонить.');
      setBusy(false);
    }
  }

  return (
    <div className="ovl" onClick={onClose}>
      <div className="modal" style={{ maxWidth: 440 }} onClick={(e) => e.stopPropagation()}>
        <div className="modal-h">
          <div className="grow">
            <div className="m-cli">⛔ Отклонить машину</div>
            <div className="m-no">
              {row.truck} · {row.deal_no}
            </div>
          </div>
          <button className="icon-btn close-x" onClick={onClose}>
            ✕
          </button>
        </div>
        <div className="mbody">
          {msg && <p className="err">{msg}</p>}
          <p className="muted small" style={{ marginBottom: 8 }}>
            Машина не будет выпущена. Комментарий увидит склад, чтобы разобраться (отменить или
            исправить рейс).
          </p>
          <label className="fld">
            <span className="fld-l">Причина отклонения</span>
            <textarea
              className="note-area"
              value={reason}
              disabled={busy}
              autoFocus
              placeholder="напр. расхождение с накладной по количеству; не тот груз"
              onChange={(e) => setReason(e.target.value)}
            />
          </label>
          <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
            <button className="btn ghost sm" disabled={busy} onClick={onClose}>
              Отмена
            </button>
            <button className="btn sm" disabled={busy} onClick={submit}>
              {busy ? 'Отклоняем…' : 'Отклонить'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
